// frontend/src/pages/Admin/ContactsManagement.jsx
import React, { useState, useEffect } from 'react';
import './AdminStyles.css';
import { contactService } from '../../services/contactService';

const ContactsManagement = () => {
  const [contacts, setContacts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    loadContacts();
  }, []);

  const loadContacts = async () => {
    try {
      const data = await contactService.getContacts();
      setContacts(data.contacts);
    } catch (error) {
      console.error('Ошибка загрузки контактов:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleContactChange = (id, field, value) => {
    setContacts(prev => 
      prev.map(contact => 
        contact.id === id ? { ...contact, [field]: value } : contact
      )
    );
  };

  const addContact = (type) => {
    const newContact = {
      id: Date.now(), // временный ID
      type,
      label: type === 'email' ? 'Email' : 
             type === 'phone' ? 'Телефон' : 
             type === 'social' ? 'Соцсеть' : 'Адрес',
      value: '',
      icon: type === 'social' ? 'instagram' : null,
      orderIndex: contacts.length
    };
    setContacts(prev => [...prev, newContact]);
  };

  const removeContact = (id) => {
    if (window.confirm('Удалить этот контакт?')) {
      setContacts(prev => prev.filter(contact => contact.id !== id));
    }
  };

  const handleSave = async () => {
    setSaving(true);
    try {
      await contactService.updateContacts(contacts);
      alert('Контакты успешно сохранены');
    } catch (error) {
      console.error('Ошибка сохранения контактов:', error);
      alert('Ошибка при сохранении');
    } finally {
      setSaving(false);
    }
  };

  if (loading) {
    return <div className="admin-loading">Загрузка...</div>;
  }

  return (
    <div className="admin-content">
      <div className="admin-header">
        <h2>Управление контактами</h2>
        <button 
          className="admin-button primary"
          onClick={handleSave}
          disabled={saving}
        >
          {saving ? 'Сохранение...' : 'Сохранить все'}
        </button>
      </div>

      <div className="contacts-sections">
        <div className="contacts-section">
          <h3>Email</h3>
          {contacts.filter(c => c.type === 'email').map(contact => (
            <div key={contact.id} className="contact-item">
              <input
                type="text"
                placeholder="Email"
                value={contact.value}
                onChange={(e) => handleContactChange(contact.id, 'value', e.target.value)}
                className="contact-input"
              />
              <button 
                className="admin-button small delete"
                onClick={() => removeContact(contact.id)}
              >
                ×
              </button>
            </div>
          ))}
          <button 
            className="admin-button secondary"
            onClick={() => addContact('email')}
          >
            Добавить email
          </button>
        </div>

        <div className="contacts-section">
          <h3>Телефоны</h3>
          {contacts.filter(c => c.type === 'phone').map(contact => (
            <div key={contact.id} className="contact-item">
              <input
                type="text"
                placeholder="Название (например, Аквапарк)"
                value={contact.label}
                onChange={(e) => handleContactChange(contact.id, 'label', e.target.value)}
                className="contact-input small"
              />
              <input
                type="text"
                placeholder="Номер телефона"
                value={contact.value}
                onChange={(e) => handleContactChange(contact.id, 'value', e.target.value)}
                className="contact-input"
              />
              <button 
                className="admin-button small delete"
                onClick={() => removeContact(contact.id)}
              >
                ×
              </button>
            </div>
          ))}
          <button 
            className="admin-button secondary"
            onClick={() => addContact('phone')}
          >
            Добавить телефон
          </button>
        </div>

        <div className="contacts-section">
          <h3>Социальные сети</h3>
          {contacts.filter(c => c.type === 'social').map(contact => (
            <div key={contact.id} className="contact-item">
              <select
                value={contact.icon}
                onChange={(e) => handleContactChange(contact.id, 'icon', e.target.value)}
                className="contact-input small"
              >
                <option value="instagram">Instagram</option>
                <option value="telegram">Telegram</option>
                <option value="whatsapp">WhatsApp</option>
              </select>
              <input
                type="text"
                placeholder="URL"
                value={contact.value}
                onChange={(e) => handleContactChange(contact.id, 'value', e.target.value)}
                className="contact-input"
              />
              <button 
                className="admin-button small delete"
                onClick={() => removeContact(contact.id)}
              >
                ×
              </button>
            </div>
          ))}
          <button 
            className="admin-button secondary"
            onClick={() => addContact('social')}
          >
            Добавить соцсеть
          </button>
        </div>

        <div className="contacts-section">
          <h3>Адрес</h3>
          {contacts.filter(c => c.type === 'address').map(contact => (
            <div key={contact.id} className="contact-item">
              <input
                type="text"
                placeholder="Адрес"
                value={contact.value}
                onChange={(e) => handleContactChange(contact.id, 'value', e.target.value)}
                className="contact-input"
              />
              <button 
                className="admin-button small delete"
                onClick={() => removeContact(contact.id)}
              >
                ×
              </button>
            </div>
          ))}
          <button 
            className="admin-button secondary"
            onClick={() => addContact('address')}
          >
            Добавить адрес
          </button>
        </div>
      </div>
    </div>
  );
};

export default ContactsManagement;